import type { FlagResolution } from '../types';

/**
 * Labels pt-BR para os enums de reconciliation (A4 REVAMP). Espelham os valores
 * canonical do `IntegrationReconciliationService` (engine). Tipos desconhecidos
 * caem no fallback (defensivo — backend pode introduzir novos sem quebrar a UI).
 */

export const FLAG_TYPE_LABEL: Record<string, string> = {
  tool_added: 'Tool adicionada',
  tool_removed: 'Tool removida',
  conflict: 'Conflito',
  missing_in_external: 'Ausente no remoto',
};

/** Descrição honesta de qual lado diverge (derivada do flagType — sem fabricar payload). */
export const FLAG_TYPE_DETAIL: Record<string, string> = {
  tool_added: 'Presente no connector remoto, ausente no registro local do Lume.',
  tool_removed: 'Presente no registro local do Lume, ausente no connector remoto.',
  conflict: 'Divergência de definição entre o registro local e o connector remoto.',
  missing_in_external: 'Esperada pelo Lume, mas o connector remoto não a expõe.',
};

export function flagTypeLabel(flagType: string): string {
  return FLAG_TYPE_LABEL[flagType] ?? flagType;
}

export const RESOLUTION_LABEL: Record<FlagResolution, string> = {
  accept_remote: 'Aceitar remoto',
  keep_local: 'Manter local',
  request_info: 'Pedir info ao operador',
};

/** Formata ISO → pt-BR legível; '—' quando null. */
export function fmtDateTime(iso: string | null): string {
  if (iso === null) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}
